<template>
    <div>
        <router-link :to="'knowledge-categories/'+row.id+ '/details'"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <i class="fa fa-eye"></i>
        </router-link>

        <router-link :to="'update-knowledge-categories/'+row.id"
                     class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <i class="fa fa-edit"></i>
        </router-link>

        <a v-if="row.is_deleted" href="#" v-on:click.prevent="restoreCat"
           class="btn btn-sm btn-clean btn-icon btn-icon-sm"
           id="restoreBtn"
        >
            <i class="fa fa-sync-alt"></i>
        </a>
        <a v-else href="#" v-on:click.prevent="deleteCat"
           class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
           id="deleteBtn"
        >
            <i class="fa fa-trash"></i>
        </a>


    </div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import {knowledgeManagementService} from '@/common/api.service'
import toastr from 'toastr'
import {KTApp} from "@/plugins/core/app";
import {i18n} from "@/plugins/i18n";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            q: {}
        }
    },
    computed: {
        selector() {
            return $('tr[data-row="'+this.index+'"')
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods : {
        deleteCat(e) {
            if (confirm(i18n.t('confirm.delete_category'))) {
                $('#deleteBtn').addClass('disabled');
                knowledgeManagementService.deleteCategory(this.row.id)
                    .then(response => {
                        this.toastr.success(response.data.message)
                        this.row.is_deleted = true
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        $('#deleteBtn').removeClass('disabled');
                        if (this.datatable.KTDatatable) {
                            this.datatable.reload();
                        }
                    })
            }
        },
        restoreCat(e) {
            $('#restoreBtn').addClass('disabled');
            knowledgeManagementService.restoreCategory(this.row.id)
                .then(response => {
                    this.toastr.success(response.data.message)
                    this.row.is_deleted = false
                })
                .catch(({response}) => {
                    this.toastr.error(response.data.message)
                })
                .finally(() => {
                    $('#restoreBtn').removeClass('disabled');
                    if (this.datatable.KTDatatable) {
                        this.datatable.reload();
                    }
                })
        }
    },
})
</script>